import { pipe, prop } from 'ramda';

import { createMatchSelector } from '@/redux/router/selectors';

import { STEP_ROUTE_PATH } from './consts';

const getParams = pipe(createMatchSelector(STEP_ROUTE_PATH), prop('params'));

export const getMallBonusId = pipe(getParams, prop('id'));
